<template>
    <multiselect :value="selectedSampleTypes" :options="searchResults" @input="updateValueAction" :multiple="true"
        class="sample-type-multi-select" :group-select="true" group-label="category" group-values="sampleTypes"
        :internal-search="false" @search-change="onSearchChange" :clearOnSelect="false" :closeOnSelect="false">
        <template slot="beforeList">
            <button class="clear-all-button m-5" v-show="selectedSampleTypes.length" @click="$emit('input', [])">
                Clear All <i></i>
            </button>
        </template>
    </multiselect>
</template>

<script>

const stringMatch = (str, qry) => {
    return str.indexOf(qry) !== -1;
};

export default {
    name: "sample-type-multi-select",
    data() {
        return {
            searchQueryString: ''
        }
    },
    props: {
        clientSampleTypeNames: Array,
        selectedSampleTypes: Array
    },
    methods: {
        updateValueAction(value) {
            this.$emit('input', value);
        },

        onSearchChange(searchQuery) {
            this.searchQueryString = searchQuery;
        }
    },
    computed: {
        searchResults() {
            const searchQuery = this.searchQueryString.toLowerCase().trim();
            return this.clientSampleTypeNames.flatMap(
                clientSampleTypeName => {
                    // If category name matches, return entire sample type
                    if (stringMatch(clientSampleTypeName.category.toLowerCase().trim(), searchQuery)) {
                        return [clientSampleTypeName];
                    }

                    const matchedSampleTypes = clientSampleTypeName.sampleTypes.filter(sampleType =>
                        stringMatch(sampleType.toLowerCase().trim(), searchQuery)
                    );

                    // Either Return clone of the clientSampleTypeName obj with filtered samples types,
                    // or an empty array (will be discarded by flatMap)
                    return (matchedSampleTypes.length > 0) ?
                        [{
                            category: clientSampleTypeName.category,
                            sampleTypes: matchedSampleTypes
                        }]
                        : [];
                }
            );
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!--You can't do scoped styles when overriding a child components styles-->
<style lang="scss">
.sample-type-multi-select {
    .multiselect__tags {
        border-radius: 0;
        border-color: rgb(130, 130, 130);

        .multiselect__tag {
            background: #26A2D9;

            .multiselect__tag-icon:focus,
            .multiselect__tag-icon:hover {
                background: #26A2D9;
            }
        }
    }

    .multiselect__option--highlight {
        background: #26A2D9;
    }

    .multiselect__option--highlight:after {
        background: #26A2D9;
    }

    // This is kinda dumb, I overrode the background color so I have to manual revert the background color for when it's selected
    .multiselect__option--selected.multiselect__option--highlight {
        background: #ff6a6a;
    }

    .multiselect__option--selected.multiselect__option--highlight:after {
        background: #ff6a6a;
    }

    .clear-all-button {
        border-radius: 5px;
        color: white;
        background-color: #ff6a6a;
        border-style: none;

        i::after {
            content: "×";
            color: black;
            font-size: 14px;
        }

        i:focus:after,
        i:hover:after {
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// sample-type-multi-select.vue?2c6c674f